import { FormSubmissionAnswer } from '../../../contracts/form-submission-answer.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { isSameList } from '../../dto/data-model-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class OptionSelectFormSubmissionAnswer extends FormSubmissionAnswer {
  static readonly TYPE_ID: string = 'b8f4a2c3d5e7f9a1b2c4d6e8f0a3b5c7';

  constructor(
    public readonly questionId: string,
    public readonly selectedOptions: string[],
  ) {
    super();
  }

  get $typeId(): string {
    return OptionSelectFormSubmissionAnswer.TYPE_ID;
  }

  static create(args: {
    questionId: string,
    selectedOptions: string[],
  }): OptionSelectFormSubmissionAnswer {
    return new OptionSelectFormSubmissionAnswer(args.questionId, args.selectedOptions);
  }

  static fromMap(context: SerializationContext, map: SerializedData): OptionSelectFormSubmissionAnswer {
    return new OptionSelectFormSubmissionAnswer(
        MapUtils.getString(map, 'questionId'),
        MapUtils.getList<string>(map, 'selectedOptions', (e) => e as string),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'questionId': this.questionId,
      'selectedOptions': this.selectedOptions,
    };
  }

  clone(): this {
    return new OptionSelectFormSubmissionAnswer(this.questionId, [...this.selectedOptions]) as this;
  }

  isSame(other: OptionSelectFormSubmissionAnswer): boolean {
    if(other === this) {
      return true;
    }

    return other.questionId === this.questionId &&
      isSameList(other.selectedOptions, this.selectedOptions);
  }
}

export class OptionSelectFormSubmissionAnswerBuilder extends DataModelBuilder<OptionSelectFormSubmissionAnswer> {
  build(context: SerializationContext, map: SerializedData): OptionSelectFormSubmissionAnswer {
    return OptionSelectFormSubmissionAnswer.fromMap(context, map);
  }
}
